import {RequestEntity} from "../../../../types/RequestEntity";
import {isSingleRequest} from "../../../../lib/isSingleRequest";
import Tooltiper from "components/Tooltiper";
import {isCombinedRequest} from "../../../../lib/isCombinedRequest";
import React from "react";

// Компонент рендеринга ячейки для количества
export const CountCellRenderer = React.memo(function CountCellRenderer({equipmentRequestEntity}: { equipmentRequestEntity: RequestEntity }) {
    return (
        <>
            {isSingleRequest(equipmentRequestEntity) &&
                <Tooltiper
                    text={equipmentRequestEntity?.count + (equipmentRequestEntity?.unitOfMeasurement?.name || '')}
                    props={{textAlign: 'center'}}/>
            }
            {isCombinedRequest(equipmentRequestEntity) &&
                <Tooltiper
                    text={`${equipmentRequestEntity?.childRequests?.reduce((acc, curr) => acc + Number(curr.count), 0)}`}
                    props={{
                        variant: 'subtitle1',
                        textAlign: 'center'
                    }}
                />}
        </>
    );
}, (prevProps, nextProps) => {
    const prev = prevProps.equipmentRequestEntity;
    const next = nextProps.equipmentRequestEntity;
    
    if (isSingleRequest(prev) && isSingleRequest(next)) {
        return (
            prev.id === next.id &&
            prev.count === next.count &&
            prev.unitOfMeasurement?.id === next.unitOfMeasurement?.id
        );
    }
    
    if (isCombinedRequest(prev) && isCombinedRequest(next)) {
        return (
            prev.id === next.id &&
            prev.childRequests?.length === next.childRequests?.length &&
            prev.childRequests?.every((req, idx) => 
                req.id === next.childRequests?.[idx]?.id &&
                req.count === next.childRequests?.[idx]?.count
            )
        );
    }
    
    return false;
});